import {
  CmpTypographyField,
  CmpInputField,
  CmpStatus,
} from "../../../Component/Common/ToolBox/ToolBox";
import { hasValueInErrorMessage } from "../../../Utility/Utilitys";
import Grid from "@mui/material/Grid";
export default function WmsFooter({
  vRdxWmsHead,
  xFooterObj,
  sArr,
  fHeadNarration,
  xKey,
  xErrorMsg,
}) {
  return (
    <div className="Wms-footer">
      <Grid
        container
        rowSpacing={{ xs: 0, sm: 0, md: 0 }}
        columnSpacing={{ xs: 0, sm: 0, md: 1 }}
        columns={{ xs: 12, sm: 12, md: 12 }}
        justifyContent={"space-between"}
      >
        <Grid item xs={12} sm={12} md={4} >
          <Grid
            container
            spacing={0}
            columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
            className={
              hasValueInErrorMessage(xErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
            <Grid item xs={3} sm={2} md={2} >
              <CmpTypographyField xcomponent={"span"} xText={"Narration"} />
            </Grid>
            <Grid item xs={10} sm={10} md={10} >
              <CmpInputField
                xtabIndex="201"
                xValue={vRdxWmsHead.A_Narr}
                xType={"text"} // text/number/password
                xName={"A_Narr"}
                xReadOnly={false}
                xOnChange={fHeadNarration}
                xError={xErrorMsg.A_Narr === "" ? false : true}
                xErrorMessage={xErrorMsg.A_Narr}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={8} lg={12} className="">
              <CmpStatus xStatus={vRdxWmsHead.A_DocStat} />
            </Grid>
          </Grid>
        </Grid>
        
         <Grid item xs={12} sm={12} md={4}  >
          <Grid
            container
            spacing={0}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              hasValueInErrorMessage(xErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
            <Grid item xs={3} sm={3} md={4} >
              <CmpTypographyField xcomponent={"span"} xText={"Net  Value "} />
            </Grid>
            <Grid item xs={3} sm={3} md={8} >
              <CmpInputField
                xtabIndex="206"
                xValue={xFooterObj.F_NetValue}
                xType={"text"} // text/number/password
                xName={""}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>
           
          </Grid>
        </Grid>
        
      </Grid>
    </div>
  );
}
